export default "__VITE_ASSET__h1YL_xCX__"